import {createSlice} from "@reduxjs/toolkit";
import languages from "../../utils/languages";

function saveLanguageToLocalStorage(language) {
    localStorage.setItem("language", JSON.stringify(language))
}

function getLanguageFromLocalStorage() {
    let language = localStorage.getItem("language")
    if (language) {
        return JSON.parse(language)
    }
    return languages[0]
}

const initalState = {
    selectedLanguageId: getLanguageFromLocalStorage().id,
    selectedLanguageObject: getLanguageFromLocalStorage()
}


const LanguageSlice = createSlice({
    name: "language",
    initialState: initalState,
    reducers: {
        setLanguage: (state, action) => {
            state.selectedLanguageId = action.payload.id
            state.selectedLanguageObject = action.payload
            saveLanguageToLocalStorage(action.payload)

            return state
        },
        resetLanguage: (state, action) => {
            state.selectedLanguageId = languages[0].id
            state.selectedLanguageObject = languages[0]
            saveLanguageToLocalStorage(state)
            return state
        }
    }
})


export const {setLanguage, resetLanguage} = LanguageSlice.actions
export default LanguageSlice.reducer